import { createApp } from 'utils/vue';
import App from "components/pages/container";
import { registerHandler } from "utils/handler";

const handler = (app) => {
  createApp(App, app.data).mount("#app-container");
};

registerHandler("index", handler);
